import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../components/common/Typography';

// 전직장, 납세조합 데이터가 없을 때 표시되는 빈 상태 메시지
const EmptyListMessage = () => {
  const { t } = useTranslation('previousEmployment');

  return (
    <div className="emptyListMessage">
      <Typography variant="body2Medium" style={{ color: 'var(--GrayScale-500)' }}>
        {t('listSection.emptyMessage3')},{'\n'}바로 다음으로 이동해도 괜찮아요.
      </Typography>
    </div>
  );
};

export default EmptyListMessage;
